import React from "react";
import SingleSelector from "@/components/SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const DeviceLogStatus = React.forwardRef(
  ({ disabled, name, value, onChange, clearable, className, style }, ref) => {
    const { t } = useTranslation();
    const status = [
      { id: "Completed", name: t({ defaultMessage: "成功" }) },
      { id: "Failed", name: t({ defaultMessage: "失败" }) }
    ];

    return (
      <SingleSelector
        placeholder={t({ defaultMessage: "选择结果" })}
        options={status}
        clearable={clearable}
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
        className={className}
        style={{ width: 180, ...style }}
      />
    );
  }
);

export default DeviceLogStatus;
